import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import banner_bottom1 from "../../../static/images/faqs/banner_bottom1.png";
import banner_bottom2 from "../../../static/images/faqs/banner_bottom2.png";

import * as ROUTES from "../../../constant/routes";

const FaqBottom = () => {
	return (
		<div className="service-section space sec">
			<div className="m-container">
				<div className="service-container">
					<div className="service-item">
						<div className="service-item__img">
							<img loading="lazy" src={banner_bottom1} alt="" />
							<div className="content">
								<h3>Cho thuê xe trên Mioto. </h3>
								<p>
									Cho thuê xe trên Mioto để gia tăng thu nhập <br /> hàng tháng và gặp gỡ nhiều bạn bè mới!
								</p>
								<Link to={ROUTES.OWNER_REGISTER} className="btn btn-primary btn--l">
									Xem thêm
								</Link>
							</div>
						</div>
					</div>
					<div className="service-item right">
						<div className="service-item__img">
							<img loading="lazy" src={banner_bottom2} alt="" />
							<div className="content">
								<h3>
									Đăng ký <br />
									GPS MITRACK 4G
								</h3>
								<p>
									MITRACK 4G với thiết kế nhỏ gọn, cho vị trí có độ <br /> chính xác cao. Các đối tác chủ xe Mioto có
									thể <br /> theo dõi vị trí và quản lý xe ngay trên ứng dụng.
								</p>
								<Link to={ROUTES.GPS_REGISTER} className="btn btn-primary btn--l">
									Xem thêm
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="service-swiper-container">
					<Swiper
						className="swiper-service"
						slidesPerView={1}
						spaceBetween={10}
						modules={[Pagination]}
						pagination={{
							el: ".pagi-service",
							clickable: true,
							dynamicBullets: true,
						}}>
						<SwiperSlide>
							<div className="fix-img">
								<img loading="lazy" src={banner_bottom1} alt="" />
							</div>
							<div className="content">
								<h3>Cho thuê xe trên Mioto. </h3>
								<p>
									Cho thuê xe trên Mioto để gia tăng thu nhập <br /> hàng tháng và gặp gỡ nhiều bạn bè mới!
								</p>
								<Link to={ROUTES.OWNER_REGISTER} className="btn btn-primary btn--l">
									Xem thêm
								</Link>
							</div>
						</SwiperSlide>
						<SwiperSlide className="right">
							<div className="fix-img">
								<img loading="lazy" src={banner_bottom2} alt="" />
							</div>
							<div className="content">
								<h3>
									Đăng ký <br />
									GPS MITRACK 4G
								</h3>
								<p>
									MITRACK 4G với thiết kế nhỏ gọn, cho vị trí có độ <br /> chính xác cao. Các đối tác chủ xe Mioto có
									thể <br /> theo dõi vị trí và quản lý xe ngay trên ứng dụng.
								</p>
								<Link to={ROUTES.GPS_REGISTER} className="btn btn-primary btn--l">
									Xem thêm
								</Link>
							</div>
						</SwiperSlide>
						<div className="swiper-pagination pagi-service" />
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default FaqBottom;
